import React from "react"
import Header from "../header"
import Footer from "../footer"

import "./index.css"

export default ({ children }) => (
    <div className="container-fluid px-0 layout-container">
        <Header />
        {children}
        <Footer />
    </div>
)